import { useContext, useEffect, useMemo } from 'react'
import { Outlet, useNavigate } from 'react-router'
import { MediaProvider } from '@wolfdanepug/media-service-nextjs'
import { AuthContext } from '@wolfdanepug/common-react'
import { Stack, Toolbar } from '@mui/material'
import { Main } from '../../components/Main'
import { Header } from '../../components/Header'
import { CartProvider } from '../../context/cart'
import { PageHeader } from '../../context/page'
import { BottomNavigationControl } from '../../components/BottomNavigationControl'
import { useLocation } from 'react-router'

export default function Layout() {
	const { useAuthToken } = useContext(AuthContext)
	const { token }: any = useAuthToken()
	const navigate = useNavigate()
	const { pathname } = useLocation()

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}, [pathname])

	// default toolbar height
	const height = 110

	const uploadHeaders = useMemo(() => {
		return {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'multipart/form-data'
		}
	}, [token])

	const redirectHandler = (path = '') => {
		if (path) {
			navigate(path)
		} else {
			navigate(-1)
		}
	}

	return (
		<MediaProvider uploadUrl={''} headers={uploadHeaders}>
			<Main>
				<Header />
				<Stack
					spacing={0}
					sx={{
						pb: {
							xs: '100px',
							md: 5
						}
					}}
				>
					<Toolbar
						sx={{
							height: {
								xs: 150,
								md: height
							},
							transition: 'height 0.3s'
						}}
					/>
					<Stack gap={3}>
						<PageHeader
							redirectHandler={redirectHandler}
							sx={{
								root: {
									// mb: 3
								},
								title: {
									fontSize: '1.7rem'
								}
							}}
						/>
						<CartProvider>
							<Outlet />
						</CartProvider>
					</Stack>
				</Stack>
				<BottomNavigationControl />
			</Main>
		</MediaProvider>
	)
}
